module.exports = __webpack_public_path__ + "img/antes_despues_150.b723dda7.png";